export default __webpack_public_path__ + "static/media/Ballroll_00166.4e8db457.png";